import { Link } from 'react-router-dom';
import { BookOpen, HelpCircle, Calculator, FileText } from 'lucide-react';

function Resources() {
    const resources = [
        {
            icon: <Calculator size={32} />,
            title: 'Mortgage Calculator',
            description: 'Our comprehensive calculator with amortization schedules, prepayment analysis, and loan comparisons',
            link: '/',
            linkText: 'Use Calculator'
        },
        {
            icon: <BookOpen size={32} />,
            title: 'Educational Articles',
            description: 'In-depth guides on mortgages, amortization, prepayment strategies, and more',
            link: '/blog',
            linkText: 'Read Articles'
        },
        {
            icon: <HelpCircle size={32} />,
            title: 'Frequently Asked Questions',
            description: 'Quick answers to common questions about mortgages and using our calculator',
            link: '/faq',
            linkText: 'View FAQs'
        }
    ];

    const topics = [
        { title: 'Understanding Amortization', slug: 'understanding-amortization-schedules' },
        { title: 'Prepayment Savings Strategies', slug: 'prepayment-can-save-thousands' },
        { title: 'PMI Explained', slug: 'pmi-explained-what-it-is-how-to-remove' },
        { title: 'Rate Buydowns vs Shopping', slug: 'mortgage-rate-buydowns-vs-shopping-for-better-rates' },
        { title: '15-Year vs 30-Year Mortgages', slug: '15-year-vs-30-year-mortgage-which-is-right' }
    ];

    return (
        <div className="container fade-in" style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem 1rem' }}>
            <header style={{ marginBottom: '3rem', textAlign: 'center' }}>
                <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>Resources</h1>
                <p style={{ fontSize: '1.25rem', color: 'var(--text-secondary)' }}>
                    Everything you need to make informed home financing decisions
                </p>
            </header>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginBottom: '3rem' }}>
                {resources.map((resource, index) => (
                    <div key={index} className="card" style={{ textAlign: 'center', border: '1px solid var(--border)' }}>
                        <div style={{ color: 'var(--primary)', marginBottom: '1rem', display: 'flex', justifyContent: 'center' }}>
                            {resource.icon}
                        </div>
                        <h3 style={{ marginBottom: '0.75rem' }}>{resource.title}</h3>
                        <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem' }}>
                            {resource.description}
                        </p>
                        <Link
                            to={resource.link}
                            className="btn btn-primary"
                            style={{ display: 'inline-block', textDecoration: 'none' }}
                        >
                            {resource.linkText}
                        </Link>
                    </div>
                ))}
            </div>

            <div className="card" style={{ marginBottom: '3rem' }}>
                <h2 style={{ marginTop: 0, marginBottom: '1.5rem' }}>Popular Topics</h2>
                <div style={{ display: 'grid', gap: '0.75rem' }}>
                    {topics.map((topic, index) => (
                        <Link
                            key={index}
                            to={`/blog/${topic.slug}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.75rem',
                                padding: '1rem',
                                backgroundColor: 'var(--background)',
                                border: '1px solid var(--border)',
                                borderRadius: '8px',
                                textDecoration: 'none',
                                color: 'inherit',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'var(--primary-light)';
                                e.currentTarget.style.borderColor = 'var(--primary)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'var(--background)';
                                e.currentTarget.style.borderColor = 'var(--border)';
                            }}
                        >
                            <FileText size={20} style={{ color: 'var(--primary)', flexShrink: 0 }} />
                            <span style={{ fontWeight: '500' }}>{topic.title}</span>
                        </Link>
                    ))}
                </div>
            </div>

            <div className="card" style={{ backgroundColor: 'var(--primary-light)', border: 'none', textAlign: 'center' }}>
                <h3 style={{ marginTop: 0, color: '#1e293b' }}>Need Help?</h3>
                <p style={{ marginBottom: '1.5rem', color: '#475569' }}>
                    Have questions or suggestions? We'd love to hear from you.
                </p>
                <a
                    href="mailto:rupdevworks@gmail.com"
                    className="btn btn-primary"
                    style={{ display: 'inline-block', textDecoration: 'none' }}
                >
                    Contact Us
                </a>
            </div>
        </div>
    );
}

export default Resources;
